<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">化学品废弃记录</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="化学品名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="化学品编号">
          <el-input v-model="formInline.item_code" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="负责人工号">
          <el-input v-model="formInline.disposal_handler_number" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="废弃日期">
          <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
            clearable start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="item_code" label="化学品编号" width="140">
        </custom-table-column>
        <custom-table-column prop="chemical.name" label="化学品名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="chemical.category" label="化学品类型" width="100">
        </custom-table-column>
        <custom-table-column prop="disposal_handler_name" label="负责人" width="120">
        </custom-table-column>
        <custom-table-column prop="disposal_handler_number" label="工号" width="120">
        </custom-table-column>
        <custom-table-column prop="disposal_location" label="废弃地点" min-width="160">
        </custom-table-column>
        <custom-table-column prop="disposal_date" label="废弃日期" width="160">
        </custom-table-column>
        <custom-table-column prop="disposal_notes" label="备注" min-width="160">
        </custom-table-column>
        <custom-table-column prop="initial_quantity" width="100" label="入库数量">
        </custom-table-column>
        <custom-table-column prop="current_quantity" width="100" label="当前库存">
        </custom-table-column>
        <custom-table-column prop="chemical.unit" label="单位" width="80">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="detailMethod(scope.row)" type="text" size="small">查看详情</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>


    <el-dialog :close-on-click-modal="false" title="详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="" direction="vertical" :column="3" border>
        <template v-if="rowObj">
          <el-descriptions-item>
            <template slot="label">化学品编号 </template> {{ rowObj.item_code }}
          </el-descriptions-item>
          <template v-if="rowObj.chemical">
            <el-descriptions-item>
              <template slot="label">化学品名称 </template> {{ rowObj.chemical.name }}
            </el-descriptions-item>
            <!-- <el-descriptions-item>
              <template slot="label">CAS号 </template> {{ rowObj.chemical.cas_number }}
            </el-descriptions-item> -->
            <el-descriptions-item>
              <template slot="label">化学品分类 </template> {{ rowObj.chemical.category }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">单位 </template> {{ rowObj.chemical.unit }}
            </el-descriptions-item>
          </template>
          <el-descriptions-item>
            <template slot="label">入库数量 </template> {{ rowObj.initial_quantity }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">当前库存 </template> {{ rowObj.current_quantity }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">废弃人 </template> {{ rowObj.disposal_handler_name }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">废弃人工号 </template> {{ rowObj.disposal_handler_number }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">废弃人地点 </template> {{ rowObj.disposal_location }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">备注 </template> {{ rowObj.disposal_notes }}
          </el-descriptions-item>
        </template>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        item_code: '',
        name: '',
        disposal_handler_number: '',
        start_date: '',
        end_date: '',
        date: ''
      },
      detailDialogVisible: false,
      organLabel: '',
      eqs: [],
      rowObj: {},
      total: 40,
      total1: 0,
    };
  },
  components: {},
  created() { },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent', { type: 'all' });
  },
  methods: {
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      if (params.date && params.date.length > 0) {
        params.start_date = params.date[0];
        params.end_date = params.date[1];
        delete params.date;
      }
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/chemical/disposal/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },


    async detailMethod(row) {
      let res = await this.$api.instance.interfaceServer(`api/chemical/disposal/detail/${row.id}`, 'get');
      if (res.code == 0 && res.data) {
        this.rowObj = res.data;
        this.detailDialogVisible = true;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },


  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
